<header>
  <h2 class="cursor-pointer" [attr.aria-label]="'Navigate to home'" (click)="goHome()" (keyup.enter)="goHome()" tabindex="0" i18n>
    Gateway
    @if (environment !== 'production') {
      ({{ environment | titlecase }})
    }
  </h2>
  @if (sessionService.user()) {
    <div id="user">
      <div class="user-id">
        <p class="bold" i18n>User:</p>
        <p class="bold" i18n>Dealer No.:</p>
        <p class="bold" i18n>Language:</p>
      </div>
      <div class="dealer-no">
        <p>{{ sessionService.user()?.name }}</p>
        <p>{{ sessionService.user()?.dealerNo }}</p>
        <p>{{ convertLanguageCode() }}</p>
      </div>
    </div>

    @if (sessionService.user()!.verified && !sessionService.user()!.passwordExpired && !sessionService.user()!.missingDefaultMfa) {
      <p-menubar [model]="menu" styleClass="py-2">
        <ng-template pTemplate="start">
          <div class="flex align-items-center gap-2">
            <input type="text" pInputText placeholder="Quick launch" class="w-8rem sm:w-auto" (keydown.enter)="launchApplication($event)" />
          </div>
        </ng-template>
        <ng-template #item let-item>
          @if (item.routerLink) {
            <a pRipple class="p-menubar-item-link cursor-pointer" [class]="item.linkClass" [routerLink]="item.routerLink" [id]="item.id">
              <span class="p-menubar-item-label">
                {{ item.label }}
              </span>
            </a>
          } @else {
            <a pRipple class="p-menubar-item-link cursor-pointer" [class]="item.linkClass" [id]="item.id">
              <span class="p-menubar-item-label">
                {{ item.label }}
              </span>
              @if (item.iconClass) {
                <i class="pi" [class]="item.iconClass" style="font-size: 1rem"></i>
              }
            </a>
          }
        </ng-template>
      </p-menubar>
    }
    <a id="logout" class="main py-2" tabindex="0" (click)="logout()" (keyup.space)="logout()" (keyup.enter)="logout()" i18n>Logout</a>
  }
  <img src="../assets/img/logo.png" alt="Suzuki Logo with White Background" i18n-alt>
</header>
<main class="mb-5">

  @if (sessionService.user()?.verified && !sessionService.user()?.passwordExpired && !sessionService.user()?.missingDefaultMfa) {
    <p-breadcrumb
      class="max-w-full"
      [home]="breadcrumbs[0]" />
  }
  <router-outlet (activate)="window.scrollTo(0,0)"></router-outlet>
</main>
<footer>
  <div id="footer-content">
    <div id="copyright" i18n>
        © This system is the copyright of Suzuki GB PLC
    </div>
    <div id="links">
      <div id="service-links" i18n>
          Version: {{ version }}
          | <a href="mailto:helpdesk@suzuki.co.uk">Help</a>
          | <a href="tel:+443300583955">0330 058 3955</a>
      </div>
      <div id="web-links" i18n>
        <a href="/policy/privacy">Privacy Policy</a>
        | <a href="/policy/cookies">Cookie Policy</a>
        | <a href="http://www.globalsuzuki.com" target="_blank" class="leftPad">Suzuki Global</a>
        | <a href="http://www.suzuki.co.uk" target="_blank">Suzuki GB Site</a>
      </div>
    </div>
  </div>
</footer>
